// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"8ea13747","498":"afc55bae","513":"f721478f","703":"09c77bf4"}[chunkId] + ".chunk.js";
};